
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import { getLevelOptions } from "../../template/common";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifCompose: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
    if (!this.data.report["舌象信息"]) {
      this.data.report["舌象信息"] = {
        舌神: [[], []],
        舌色: [[], []],
        舌形: [[], []],
        舌态: [[], []],
        苔质: [[], []],
        苔色: [[], []],
      };
      // 转格式,填充数据
      const oldData: any = this.data.report["舌象信息输出"];
      // 舌色
      if (oldData[0]) {
        const text: any = oldData[0];
        this.data.report["舌象信息"]["舌色"][0].push(text);
      }
      // 边尖红
      if (oldData[1] && oldData[1] == "有") {
        this.data.report["舌象信息"]["舌色"][1].push("边尖红");
      }
      // 瘀斑瘀点
      if (oldData[2] && oldData[2] == "有") {
        this.data.report["舌象信息"]["舌形"][0].push("有瘀斑瘀点");
      }
      // 苔色
      if (oldData[3]) {
        const text: any = oldData[3];
        this.data.report["舌象信息"]["苔色"][0].push(text);
      }
      // 厚薄
      if (oldData[4]) {
        const text: any = oldData[4];
        this.data.report["舌象信息"]["苔质"][0].push(text);
      }
      // 腻
      if (oldData[5] && oldData[5] == "有") {
        this.data.report["舌象信息"]["苔质"][0].push("腻");
      }
      // 腐
      if (oldData[6] && oldData[6] == "有") {
        this.data.report["舌象信息"]["苔质"][0].push("腐");
      }
      // 苔剥
      if (oldData[7] && oldData[7] == "有") {
        this.data.report["舌象信息"]["苔质"][0].push("有苔剥");
      }
      // 胖瘦
      if (oldData[8]) {
        const text: any = oldData[8];
        this.data.report["舌象信息"]["舌形"][0].push(text);
      }
      // 齿痕
      if (oldData[9] && oldData[9] == "有") {
        this.data.report["舌象信息"]["舌形"][0].push("齿痕");
      }
      // 点刺
      if (oldData[10] && oldData[10] == "有") {
        this.data.report["舌象信息"]["舌形"][0].push("点刺");
      }
      // 裂纹
      if (oldData[11] && oldData[11] == "有") {
        this.data.report["舌象信息"]["舌形"][0].push("裂纹");
      }
      this.$forceUpdate();
    }
  }
  private data: any = {};
  private colors: any = [
    "#08C664",
    "#ECA12C",
    "#F60D0D",
    "#F541F3",
    "#19DDDB",
    "#94E51A",
    "#0CCDA9",
    "#DFD111",
    "#A911DF",
    "#6D65EE",
  ];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @param val <string array>
   */
  private getShowContent(val: any) {
    let result: any = "";
    if (val && val.length > 0) {
      result = val.join("、");
    }
    return result;
  }
  private editorChange(e: any) {
    this.data.report.suggest = e;
    this.change();
  }
  private change() {
    this.$emit("changeData", this.data);
  }
  private changeTaiContent(e: any) {
    const index: any = e.findIndex((val: any) => {
      return val == "无苔";
    });
    if (index != -1) {
      this.data.report["舌象信息"]["苔色"] = [[], []];
    }
    this.change();
  }
  private getLevelOptions(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  private open(url: any) {
    window.open(url);
  }
  private mounted() { }
}
